module.exports = "/images/tk.svg?227f5c92c34366708adcb4a2311047c0";